import React from 'react';
import withRouter from 'with-router'
import { bindActionCreators } from 'redux'
import { connect, ReactReduxContext } from 'react-redux'
import PropTypes from 'prop-types';
import withStyles from '../../withStylesAdapter';
import { alpha } from '@mui/material/styles';
import classNames from 'classnames';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import CircularProgress from '@mui/material/CircularProgress';
import _ from 'lodash';
import { Resizable } from "re-resizable";
import { CodeMirror } from '../../utils/CodeMirror';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import CallMergeOutlinedIcon from '@mui/icons-material/CallMergeOutlined';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import Badge from '@mui/material/Badge';
import { Alert } from '@mui/material';
import { Trans, withTranslation, useTranslation } from 'react-i18next';
import LinkIcon from '@mui/icons-material/Link';
import SaveAltOutlinedIcon from '@mui/icons-material/SaveAltOutlined';
import Tooltip from '@mui/material/Tooltip';
import LocalHistorySelect, { LocalHistory } from '../../components/LocalHistory';
import { CONSOLE_LEVELS } from '@sentry/utils';
import { compare } from 'compare-versions';
import API from '../../api/api';

import LangifyActivation, {ManuallyAddLangifyCode} from '../../components/ThemeAppExtension';
import CollapsableSection from '../../components/CollapsableSection';

// upper bound for the content observer mutation limit; support snippets have used up to 80
const MAX_MUTATIONS_CAP = 100;
import LoadingIndicator from '../../components/LoadingIndicator';
import OptionsMenu from '../../components/OptionsMenu';
import DontAskAgainDialog from '../../components/DontAskAgainDialog.js';
import { publishTranslations, unpublishTranslations, refreshTranslations } from '../../modules/themes';
import { updateSwitcherLanguages, uploadFlagIcons } from '../../modules/switcherConfigurator';
import { syncThemeAppExtension, checkThemePublishState } from '../../modules/themeAppExtension';
import { red } from '@mui/material/colors';

function decimalToSemanticVersion(version) {
  if(version.indexOf('.') >= 0) {
    return version;
  }

  var semanticFormat = (version > 10) ? (version/10).toString() : version.toString();

  if(semanticFormat.split('.').length === 1) semanticFormat += '.0.0';
  if(semanticFormat.split('.').length === 2) semanticFormat += '.0';
  return semanticFormat;
}




function TabContainer(props) {
  return (
    <div className={props.className ? props.className : null} style={{ padding: 8 * 3, width: '100%' }}>
      {props.children}
    </div>
  );
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div>{children}</div>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}



const fileNames = [];
fileNames['themeScript'] = 'layout/theme.liquid';
fileNames['lyLiquidScript'] = 'snippets/ly-liquid-scripts.liquid';
fileNames['lyCoreScripts'] = 'snippets/ly-core-scripts.liquid';
fileNames['lyGetCustoms'] = 'snippets/ly-get-customs.liquid';
fileNames['lySwitcherFactory'] = 'snippets/ly-switcher-factory.liquid';
fileNames['lyRTLCSS'] = 'assets/ly-rtl.css.liquid';


class ThemesSection extends React.Component {

  lyDelimiter = '{% comment %}ly_liquid_scripts_begin{% endcomment %}{% capture ly_liquid_content %}{% comment %}ly_liquid_scripts_end{% endcomment %}<!doctype html>';
  themeSettings = {};

  constructor(props) {
    super(props);
     
    this.state = {
      tabIndex: 0,
      loaded: false,
      settingsChanged: false,
      pending: true,
      noticeShow: false,
      noticeType: 'error',
      blacklistLink: '',
      isPublished: false,
      //isPublishedInTheme: false,
      scrollToTop: true,

      debug: false,
      lazyload: false,
      observe: true,
      observeLinks: false,
      observeImages: true,
      observeCustomContents: true,
      linksBlacklist: [],
      loadJquery: false,
      nonStrict: false,
      languageInCartAttribute: false,
      usePlaceholderMatching: false,
      // empty = the lib default (5); only a valid number is written to the metafield
      maxMutations: '',
      // a window.langify.settings script found in the theme; it overrides the metafield
      customSettingsScript: null,

      removingV1Code: false,
      removingV1CodeProgress: 0,
      removingV1CodeComplete: false,

      /* DEPRECATED
      customizedScriptExpanded: null,

      isLoadingScript: false,
      isLoadingScriptName: '',
      showConfirmLoadDefaultDialog: false,
      
      themeScript: null,
      currentThemeScript: null,

      lyLiquidScript: null,
      currentLyLiquidScript: null,

      lyCoreScripts: null,
      currentLyCoreScripts: null,

      lyGetCustoms: null,
      currentLyGetCustoms: null,

      lySwitcherFactory: null,
      currentLySwitcherFactory: null,

      lyRTLCSS: null,
      currentLyRTLCSS: null,

      updateScripts: false,
      scriptSettings: null,
      */
    }
  }

  componentDidMount() {
    this.checkThemePublishState();
    this.checkThemeExtensionPublishState();
    setTimeout(this.loadThemeSettings, 100);
  }

  componentWillReceiveProps(newProps) {
    //this.setState({ isPublished: newProps.is_published });

    // published
    if(this.props.publish_transations_pending != newProps.publish_transations_pending && !newProps.publish_transations_pending) {
      //this.setState({ noticeShow: false, isPublished: newProps.is_published });
    }
    // unpublished
    if(this.props.unpublish_transations_pending != newProps.unpublish_transations_pending && !newProps.unpublish_transations_pending) {
      //if(!this.state.isPublishedInTheme) {
        //this.setState({ noticeShow: true, isPublished: newProps.is_published });
      //}
    }

    let noticeShow = false;
    if(!newProps.langify_code_in_theme && !newProps.langify_app_embed_code_in_theme) {
      if(typeof newProps.uuid === 'string' && newProps.disabled || !newProps.uuid) {
        noticeShow = true;
      }
    }
    this.setState({
      noticeShow: noticeShow
    })
  }

  checkThemePublishState = () => {
    this.props.checkThemePublishState(this.props.editTheme).then(() => {
      if(this.props.langify_code_in_theme === false) {
        this.setState({
          pending: false,
          //isPublishedInTheme: false,
          //noticeShow: this.state.isPublished ? false : true,
        });
      }
      if(this.props.langify_code_in_theme === true) {
        this.setState({
          pending: false,
          //isPublishedInTheme: true,
        });
      }
    });
  }

  checkThemeExtensionPublishState = () => {
    this.props.syncThemeAppExtension(this.props.editTheme).then(() => {
      if(this.props.disabled === true) {
        this.setState({
          pending: false,
          //noticeShow: this.state.isPublishedInTheme ? false : true,
          noticeType: 'error',
        });
      } else {
        this.setState({
          pending: false,
          isPublished: true,
        });
      }
    });
  }

  loadThemeSettings = () => {
    if(!this.props.themes.themes.find(x => x.id == this.props.editTheme)) {
      return;
    }

    this.setState({loaded: false});

    const currentTheme = this.props.themes.themes.find(x => x.id == this.props.editTheme);
    API.getCustomSettingsScript(currentTheme.shopify_id, (data) => {
      this.setState({ customSettingsScript: data && data.success ? data : null });
    });
    API.getMetafield('global', `ly_theme_settings_${currentTheme.shopify_id}`, (data) => {
      if(data.success && data.result && data.result.value) {
        let options = JSON.parse(data.result.value);
        if(options) {
          // Checken ob ly_theme_settings_global 
          API.getMetafield('global', 'ly_theme_settings_global', (data2) => {
            if(data2.success && data2.result.length === 0) {
              API.saveCustomMetafield('global', 'ly_theme_settings_global', JSON.stringify(options), 'json_string', (res) => {
                
              });
            }
          });
          this.themeSettings = options;
          this.setState({
            ...options,
            loaded: true
          });
        } 
      } else {
        this.setState({loaded: true});
      }
    });

    /*
    API.getScriptSettings(
      currentTheme.shopify_id,
      response => {
        if(response.success == true) {
          const updateScripts = this.checkUpdateScriptsAvailable(response.script_settings);
          this.setState({scriptSettings: response.script_settings, updateScripts: updateScripts, noticeShow: !this.state.isPublished || updateScripts});
        }
    });
    */

    this.setState({
      pending: false,

    });
  }

  checkUpdateScriptsAvailable = (scriptSettings) => {
      const versions = scriptSettings.versions;
      const customized = scriptSettings.customized;

      let updateScripts = false;
      if(
        customized["layout/theme.liquid"] ||
        customized["snippets/ly-core-scripts.liquid"] ||
        customized["snippets/ly-get-customs.liquid"] ||
        customized["snippets/ly-liquid-scripts.liquid"] ||
        customized["snippets/ly-switcher-factory.liquid"] ||
        customized["assets/ly-rtl.css.liquid"]
      ) {
        updateScripts = compare(decimalToSemanticVersion(versions.latest["layout/theme.liquid"]), decimalToSemanticVersion(versions.current["layout/theme.liquid"]), '>') ||
                        compare(decimalToSemanticVersion(versions.latest["snippets/ly-core-scripts.liquid"]), decimalToSemanticVersion(versions.current["snippets/ly-core-scripts.liquid"]), '>') ||
                        compare(decimalToSemanticVersion(versions.latest["snippets/ly-get-customs.liquid"]), decimalToSemanticVersion(versions.current["snippets/ly-get-customs.liquid"]), '>') ||
                        compare(decimalToSemanticVersion(versions.latest["snippets/ly-liquid-scripts.liquid"]), decimalToSemanticVersion(versions.current["snippets/ly-liquid-scripts.liquid"]), '>') ||
                        compare(decimalToSemanticVersion(versions.latest["snippets/ly-switcher-factory.liquid"]), decimalToSemanticVersion(versions.current["snippets/ly-switcher-factory.liquid"]), '>') ||
                        compare(decimalToSemanticVersion(versions.latest["assets/ly-rtl.css.liquid"]), decimalToSemanticVersion(versions.current["assets/ly-rtl.css.liquid"]), '>');
      }

      return updateScripts;
  };

  // the stepper buttons of the mutation limit; an empty field counts as the lib default 5
  stepMaxMutations = (delta) => {
    const current = parseInt(this.state.maxMutations, 10) >= 1 ? parseInt(this.state.maxMutations, 10) : 5;
    const next = Math.min(MAX_MUTATIONS_CAP, Math.max(1, current + delta));
    this.setState({ maxMutations: next, settingsChanged: true }, this.checkSettingsDiff);
  }

  // The app embed reads the theme settings metafield for the theme id in its block settings, and
  // falls back to the global copy (written for the main theme) when the id is empty. Anything else
  // means the settings saved here never reach the storefront. Block data comes from the
  // themeAppExtension slice (settings_data.json), the same source as the "not published" notice.
  appEmbedThemeIdProblem = () => {
    const { uuid, disabled, themeAppExtension } = this.props;
    const currentTheme = this.props.themes.themes.find(x => x.id == this.props.editTheme);
    if(typeof uuid !== 'string' || disabled === true || !currentTheme) return null;
    const expected = String(currentTheme.shopify_id);
    const actual = String(themeAppExtension?.settings?.theme_id ?? '').trim();
    if(actual === '') return currentTheme.role === 'main' ? null : { expected, actual: null };
    return actual === expected ? null : { expected, actual };
  }

  getCurrentSettings = () => {
    var result = {
      debug: this.state.debug,
      lazyload: this.state.lazyload,
      observe: this.state.observe,
      observeLinks: this.state.observeLinks,
      observeImages: this.state.observeImages,
      observeCustomContents: this.state.observeCustomContents,
      linksBlacklist: this.state.linksBlacklist,
      loadJquery: this.state.loadJquery,
      nonStrict: this.state.nonStrict,
      languageInCartAttribute: this.state.languageInCartAttribute,
      usePlaceholderMatching: this.state.usePlaceholderMatching
    };
    // left out when empty or invalid, so the storefront lib falls back to its default
    const maxMutations = parseInt(this.state.maxMutations, 10);
    if(maxMutations >= 1) result.maxMutations = Math.min(MAX_MUTATIONS_CAP, maxMutations);
    return result;
  }
  
  handleSaveThemeSettings = () => {
    this.setState({pending: true});
    const options = this.getCurrentSettings();
    const currentTheme = this.props.themes.themes.find(x => x.id == this.props.editTheme);
    API.saveCustomMetafield('translation_mode', `ly${currentTheme.shopify_id}`, options.nonStrict ? 'non-strict' : 'strict', 'single_line_text_field', (res) => {

    });
    if(this.props.themes.themes.find(x => x.role === 'main').id == this.props.editTheme) {
      API.saveCustomMetafield('global', `ly_theme_settings_global`, JSON.stringify(options), 'json_string', (res) => {

      });
    }

    API.saveCustomMetafield('global', `ly_theme_settings_${currentTheme.shopify_id}`, JSON.stringify(options), 'json_string', (res) => {
      this.themeSettings = options;
      this.setState({
        loaded: true,
        pending: false,
        settingsChanged: false
      });
    });

    /* DEPRECATED
    API.saveCustomMetafield('global', `ly_theme_settings_${currentTheme.shopify_id}`, JSON.stringify(options), 'json_string', (res) => {
      this.themeSettings = options;
      const assetsToSave = [];
      if(!_.isEqual(this.state.themeScript, this.state.currentThemeScript)) {
        assetsToSave.push(
          {
            key: 'layout/theme.liquid',
            value: this.state.themeScript
          }
        );
        LocalHistory.addHistoryEntry('layout/theme.liquid', null, this.state.themeScript, this.state.currentThemeScript);
      }
      if(!_.isEqual(this.state.lyLiquidScript, this.state.currentLyLiquidScript)) {
        assetsToSave.push(
          {
            key: 'snippets/ly-liquid-scripts.liquid',
            value: this.state.lyLiquidScript
          }
        );
        LocalHistory.addHistoryEntry('snippets/ly-liquid-scripts.liquid', null, this.state.lyLiquidScript, this.state.currentLyLiquidScript);
      }
      if(!_.isEqual(this.state.lyCoreScripts, this.state.currentLyCoreScripts)) {
        assetsToSave.push(
          {
            key: 'snippets/ly-core-scripts.liquid',
            value: this.state.lyCoreScripts
          }
        );
        LocalHistory.addHistoryEntry('snippets/ly-core-scripts.liquid', null, this.state.lyCoreScripts, this.state.currentLyCoreScripts);
      }
      if(!_.isEqual(this.state.lyGetCustoms, this.state.currentLyGetCustoms)) {
        assetsToSave.push(
          {
            key: 'snippets/ly-get-customs.liquid',
            value: this.state.lyGetCustoms
          }
        );
        LocalHistory.addHistoryEntry('snippets/ly-get-customs.liquid', null, this.state.lyGetCustoms, this.state.currentLyGetCustoms);
      }

      if(!_.isEqual(this.state.lySwitcherFactory, this.state.currentLySwitcherFactory)) {
        assetsToSave.push(
          {
            key: 'snippets/ly-switcher-factory.liquid',
            value: this.state.lySwitcherFactory
          }
        );
        LocalHistory.addHistoryEntry('snippets/ly-switcher-factory.liquid', null, this.state.lySwitcherFactory, this.state.currentLySwitcherFactory);
      }

      if(!_.isEqual(this.state.lyRTLCSS, this.state.currentLyRTLCSS)) {
        assetsToSave.push(
          {
            key: 'assets/ly-rtl.css.liquid',
            value: this.state.lyRTLCSS
          }
        );
        LocalHistory.addHistoryEntry('assets/ly-rtl.css.liquid', null, this.state.lyRTLCSS, this.state.currentLyRTLCSS);
      }

      API.saveCustomizedAssets(
        this.props.editTheme,
        assetsToSave,
        result => {
          const usedResult = result.slice(-1)[0];
          const scriptSettings = usedResult ? usedResult.script_settings : false;
          
          this.setState({
            loaded: true,
            pending: false,
            settingsChanged: false,
            currentThemeScript: this.state.themeScript,
            currentLyLiquidScript: this.state.lyLiquidScript,
            currentLyCoreScripts: this.state.lyCoreScripts,
            currentLyGetCustoms: this.state.lyGetCustoms,
            currentLySwitcherFactory: this.state.lySwitcherFactory,
            currentLyRTLCSS: this.state.lyRTLCSS,
            scriptSettings: scriptSettings ? scriptSettings : this.state.scriptSettings,
          });
        }
      )
    });
    */
  }

  onImport = (e) => {
    this.setState({ optionsMenuAnchorEl: null });
    const reader = new FileReader();
    const file = e.target.files[0];
    const fileType = file.name.substr(file.name.lastIndexOf('.') + 1);
    if(fileType != 'json') {
      return;
    }
    reader.onloadend = (evt) => {
      if (evt.target.readyState == FileReader.DONE) {
        const options = JSON.parse(evt.target.result);
        if(options) {
          this.setState({...options}, this.handleSaveThemeSettings);
        }
      }
    };
    var blob = file.slice(0, file.size);
    reader.readAsBinaryString(blob);
  }

  onExport = () => {
    const download = (filename, text) => {
      var element = document.createElement('a');
      element.setAttribute('href', 'data:application/json;charset=utf-8,' + encodeURIComponent(text));
      element.setAttribute('download', filename);
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    }
    download(`theme-config-${this.props.editTheme}.json`, JSON.stringify(this.getCurrentSettings()));
  }
 
  onResaveAll = () => {
    this.handleSaveThemeSettings();
  }

  handleChangeTab = (event, tabIndex) => {
    this.setState({ 
      tabIndex,
      scrollToTop: !this.state.scrollToTop,
    });
  };

  handleChange = name => event => {
    let value = null;
    if(event.target.type === 'checkbox') {
      value = event.target.checked;
    }
    if(event.target.type === 'text' || event.target.type === 'number') {
      value = event.target.value;
    }
    this.setState({ 
      [name]: value,
      settingsChanged: true,  
    }, this.checkSettingsDiff);
  };

  checkSettingsDiff = () => {
    if(
      _.isEqual(this.themeSettings, this.getCurrentSettings()) &&
      _.isEqual(this.state.themeScript, this.state.currentThemeScript) &&
      _.isEqual(this.state.lyLiquidScript, this.state.currentLyLiquidScript) &&
      _.isEqual(this.state.lyCoreScripts, this.state.currentLyCoreScripts) &&
      _.isEqual(this.state.lyGetCustoms, this.state.currentLyGetCustoms) &&
      _.isEqual(this.state.lySwitcherFactory, this.state.currentLySwitcherFactory) &&
      _.isEqual(this.state.lyRTLCSS, this.state.currentLyRTLCSS)
    ) {
      this.setState({settingsChanged: false});
    }
  }

  handlePublishTranslations = (id) => {
    this.props.publishTranslations(id);
    //uploadFlagIcons(this.props.languages.languages, this.props.editTheme);
    this.handleSaveThemeSettings();
    this.props.updateSwitcherLanguages(this.props.languages.languages, this.props.editTheme, this.props.themes.themes);
  }

  handleUnpublishTranslations = (id) => {
    this.props.unpublishTranslations(id, true, () => {
      setTimeout(() => {
        this.checkThemePublishState();
        this.checkThemeExtensionPublishState();
        this.props.rerender();
      }, 1000);
    });
  }

  handleRefreshTranslations = (id) => {
    this.props.refreshTranslations(id);
  }

  handleAddLink = (event) => {
    if(this.state.blacklistLink == '')
      return null;
    this.setState({ 
      linksBlacklist: this.state.linksBlacklist.concat(this.state.blacklistLink),
      blacklistLink: '', 
      settingsChanged: true, 
    });
  }

  handleDeleteLink = (link) => {
    let temp = this.state.linksBlacklist.filter(i => i != link);
    this.setState({ 
      linksBlacklist: temp,
      settingsChanged: true, 
    });
  }

  handleCancel = () => {
    this.setState({
      tabIndex: 0,
      settingsChanged: false,
      ...this.themeSettings,
      themeScript: this.state.currentThemeScript,
      lyLiquidScript: this.state.currentLyLiquidScript,
      lyCoreScripts: this.state.currentLyCoreScripts,
      lyGetCustoms: this.state.currentLyGetCustoms,
      lySwitcherFactory: this.state.currentLySwitcherFactory,
      lyRTLCSS: this.state.currentLyRTLCSS
    });
  }

  deleteV1Code = (id) => {
    this.setState({
      removingV1Code: true,
      removingV1CodeProgress: 0
    })

    API.deleteV1Code(id,
      progress => {
        this.setState({
          removingV1CodeProgress: progress
        })
      },
      () => {
        this.setState({
          removingV1Code: false,
          removingV1CodeComplete: true
        })
      }
    );
  }

  handleMigrateToEmbedApp = (id) => {
    this.props.unpublishTranslations(id, true, () => {
      //this.props.rerender();
    });
  }


  renderGeneralTab = () => {
    const { t, classes } = this.props;
    const currentTheme = this.props.themes.themes.find(x => x.id == this.props.editTheme);

    // Daten ausfüllen
    const myshopifyDomain = this.props.shop.shop.url;
    const template = false; //'index'; // oder ein anderer Template-Name
    const uuid = this.props.uuid; //'264d9cf2-73be-4f41-b7cb-58ec8e14057d'; // Beispiel UUID
    const disabled = this.props.disabled;
    const handle = 'langify'; // Beispiel Handle

    var currentDate = new Date();
    var targetDate = new Date('2025-02-01');
    var isBeforeTargetDate = currentDate < targetDate;

    let ellipsisText = currentTheme.name;
    let maxLength = 24;
    ellipsisText = ellipsisText.length>maxLength ? ellipsisText.substring(0, maxLength) + "..." : ellipsisText;

    return (
      <TabContainer>
        <FormControl
          component="fieldset"
          className={classNames(classes.formControl, 'outer')}
          style={{margin: 0}}>
          {/*<Typography variant="h6" component="h3">{t('themeSettings.generalTitle')}</Typography>*/}

          {this.props.langify_code_in_theme === true &&
            <React.Fragment>
              <Typography variant="h6" component="h3">{t('themeSettings.generalTitle')}</Typography>
              <Typography variant="body1">
                <Trans i18nKey={'themeAppExtension.themeSettings.unpublishDescription'}>
                  {t('themeAppExtension.manuallyAddLangifyCode.unpublishDescription')}
                </Trans>
              </Typography>
              {/* ---- Old Button ----
              <React.Fragment>
                <Typography variant="body1">
                  <Trans i18nKey={'themeAppExtension.themeSettings.migrationDescription'} />
                </Typography>
                <Typography variant="body1">
                  <Trans i18nKey={'themeSettings.generalDescriptionPublished'} />
                </Typography>
                <Button variant="contained" disabled={(this.props.unpublish_transations_pending || this.props.refresh_transations_pending)} size="large" color="primary" onClick={() => this.handleUnpublishTranslations(currentTheme.id)} className={classes.unpublishBtn} style={{marginBottom: 12}}>
                  {t('themeSettings.unpublishButton')} - <small> {ellipsisText} {currentTheme.role === 'main' && '(main)'}</small>
                  {this.props.unpublish_transations_pending &&
                    <CircularProgress color="primary" size={16} style={{marginLeft: 10}} />
                  }
                </Button>  
                <Typography variant="body2">
                  <Trans i18nKey={'themeSettings.generalDescriptionPublished2'} />
                </Typography>              
              </React.Fragment>
              */}
              <React.Fragment>
                {/* ---- Manually Un-publish theme.liquid ---- */}
                <ManuallyAddLangifyCode
                  showAlways={true}
                  showInline={true}
                  hideHeadline={true}
                  hideDescription={true}
                  publish={false}
                  templates={['layout/theme.liquid']}
                />
              </React.Fragment>
            </React.Fragment>
          }

          {this.props.langify_code_in_theme === false && 
            <React.Fragment>
              <LangifyActivation
                activate={(!uuid || disabled) ? true : false}
                myshopifyDomain={myshopifyDomain}
                template={template}
                handle={handle}
              />
              {((typeof uuid === 'string' && disabled === false) || this.props.langify_app_embed_code_in_theme) &&
                <React.Fragment>
                  <Divider className={classNames(classes.divider, 'large')} />
                  <ManuallyAddLangifyCode
                    showCheckMark={true}
                    showAlways={true}
                    showInline={true}
                    publish={!this.props.langify_app_embed_code_in_theme}
                    templates={['layout/theme.liquid']}
                  />
                </React.Fragment>
              }
            </React.Fragment>
          }
        </FormControl>
      </TabContainer>
    );
  }

  renderCoreTab = () => {
    const { t, classes } = this.props;
    const currentTheme = this.props.themes.themes.find(x => x.id == this.props.editTheme);
    
    return (
      <TabContainer className={classes.advancedSettingsWrapper}>
        <Grid container spacing={6}>
          <Grid size={12} style={{paddingBottom: 0}}>
            <Typography variant="h6" component="h3">{t('themeSettings.coreSettings')}</Typography>
          </Grid>
          <Grid size={{ xs: 12, lg: 6 }}>
            <FormControl component="fieldset" className={classes.formControl}>
              <FormLabel component="legend">
                {t('themeSettings.contentObserverTitle')}
                <FormControlLabel
                  className={classes.switchContainer}
                  control={
                    <Switch checked={this.state.observe} onChange={this.handleChange('observe')} value="observe" />
                  }
                  label={<Typography variant="caption">{this.state.observe ? t('system.enabled') : t('system.disabled')}</Typography>}
                  labelPlacement="start"
                />
              </FormLabel>
              <FormGroup>
                <Divider style={{marginTop: 16, marginBottom: 0}} /> 
                <Typography variant="body2" style={{marginTop: 16, marginBottom: 0}}>
                  {t('themeSettings.contentObserverInfo')}
                </Typography>      
              </FormGroup>
            </FormControl>
            
            <FormControl component="fieldset" className={classes.formControl}>
              <FormGroup>
                <FormLabel component="legend">
                  {t('themeSettings.asyncCustomContentsTitle')}
                  <FormControlLabel
                    control={
                      <Switch disabled={!this.state.observe} checked={this.state.observeCustomContents} onChange={this.handleChange('observeCustomContents')} value="observeCustomContents" />
                    }
                    className={classes.switchContainer}
                    label={<Typography variant="caption">{this.state.observeCustomContents ? t('system.enabled') : t('system.disabled')}</Typography>}
                    labelPlacement="start"
                  />
                </FormLabel>
                <Divider style={{marginTop: 16, marginBottom: 0}} /> 
                <Typography variant="body2" style={{marginTop: 16, marginBottom: 0}}>
                  {t('themeSettings.asyncCustomContentsInfo')}
                </Typography>          
              </FormGroup>
            </FormControl>

            <FormControl component="fieldset" className={classes.formControl}>
              <FormLabel component="legend">
                {t('themeSettings.lazyloadTitle')}
                <FormControlLabel
                  className={classes.switchContainer}
                  control={
                    <Switch checked={this.state.lazyload} onChange={this.handleChange('lazyload')} value="lazyload" />
                  }
                  label={<Typography variant="caption">{this.state.lazyload ? t('system.enabled') : t('system.disabled')}</Typography>}
                  labelPlacement="start"
                />
              </FormLabel>
              <FormGroup>
                <Divider style={{marginTop: 16, marginBottom: 0}} /> 
                <Typography variant="body2" style={{marginTop: 16, marginBottom: 0}}>
                  {t('themeSettings.lazyloadInfo1')}
                </Typography>
              </FormGroup>
            </FormControl>
            
            <FormControl component="fieldset" className={classes.formControl}>
              <FormGroup>
                <FormLabel component="legend">
                  Use Placeholder Matching
                  <FormControlLabel
                    control={
                      <Switch disabled={!this.state.observe} checked={this.state.usePlaceholderMatching} onChange={this.handleChange('usePlaceholderMatching')} value="usePlaceholderMatching" />
                    }
                    className={classes.switchContainer}
                    label={<Typography variant="caption">{this.state.usePlaceholderMatching ? t('system.enabled') : t('system.disabled')}</Typography>}
                    labelPlacement="start"
                  />
                </FormLabel>
                <Divider style={{marginTop: 16, marginBottom: 0}} /> 
                <Typography variant="body2" style={{marginTop: 16, marginBottom: 8}}>
                  Enables liquid-placeholder matching functionality for improved custom content translation.
                </Typography>          
              </FormGroup>
            </FormControl>

            <FormControl component="fieldset" className={classes.formControl}>
              <FormGroup>
                <FormLabel component="legend">
                  {t('themeSettings.imageTranslationTitle')}    
                  <FormControlLabel
                    control={
                      <Switch disabled={!this.state.observe} checked={this.state.observeImages} onChange={this.handleChange('observeImages')} value="observeImages" />
                    }
                    className={classes.switchContainer}
                    label={<Typography variant="caption">{this.state.observeImages ? t('system.enabled') : t('system.disabled')}</Typography>}
                    labelPlacement="start"
                  />
                </FormLabel>
                <Divider style={{marginTop: 16, marginBottom: 0}} /> 
                <Typography variant="body2" style={{marginTop: 16, marginBottom: 0}}>
                  {t('themeSettings.imageTranslationInfo')}
                </Typography>     
              </FormGroup>
            </FormControl>

            <FormControl component="fieldset" className={classes.formControl}>
              <FormGroup>
                <FormLabel component="legend">
                  {t('themeSettings.maxMutationsTitle')}
                  {/* a stepper on the legend line, where the other rows keep their switch: the buttons
                      say "adjust me" where a bare number would read as a label. Underline variant on
                      purpose: the section styles every nested legend full width (row titles), which
                      eats the top border of an outlined field's label notch */}
                  <TextField
                    style={{ position: 'absolute', right: 8, top: -8 }}
                    type="number"
                    size="small"
                    variant="standard"
                    disabled={!this.state.observe}
                    value={this.state.maxMutations}
                    onChange={this.handleChange('maxMutations')}
                    placeholder="5"
                    inputProps={{ min: 1, max: MAX_MUTATIONS_CAP, style: { width: 40, textAlign: 'center', padding: '6px 0', fontSize: 14, MozAppearance: 'textfield' } }}
                    sx={{ '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': { WebkitAppearance: 'none', margin: 0 } }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start" sx={{ mr: 0 }}>
                          <IconButton size="small" edge="start" disabled={!this.state.observe} onClick={() => this.stepMaxMutations(-1)} aria-label="decrease"><RemoveIcon fontSize="small" /></IconButton>
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end" sx={{ ml: 0 }}>
                          <IconButton size="small" edge="end" disabled={!this.state.observe} onClick={() => this.stepMaxMutations(1)} aria-label="increase"><AddIcon fontSize="small" /></IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormLabel>
                <Divider style={{marginTop: 16, marginBottom: 0}} /> 
                <Typography variant="body2" style={{marginTop: 16, marginBottom: 0}}>
                  {t('themeSettings.maxMutationsInfo')}
                </Typography>
                {this.state.customSettingsScript?.found &&
                  <Alert severity="warning" style={{marginTop: 12}}>
                    {this.state.customSettingsScript.max_mutations
                      ? t('themeSettings.maxMutationsScriptWarning', { value: this.state.customSettingsScript.max_mutations })
                      : t('themeSettings.maxMutationsScriptWarningNoValue')}
                  </Alert>
                }
              </FormGroup>
            </FormControl>
          </Grid>        
          
          <Grid size={{ xs: 12, lg: 6 }}>

            <FormControl component="fieldset" className={classes.formControl}>
              <FormLabel component="legend">
                {t('themeSettings.linkCorrectionTitle')}
                <FormControlLabel
                  className={classes.switchContainer}
                  control={
                    <Switch disabled={!this.state.observe} checked={this.state.observeLinks} onChange={this.handleChange('observeLinks')} value="observeLinks" />
                  }
                  label={<Typography variant="caption">{this.state.observeLinks ? t('system.enabled') : t('system.disabled')}</Typography>}
                  labelPlacement="start"
                />   
              </FormLabel>
              <FormGroup>
                <Divider style={{marginTop: 16, marginBottom: 0}} />
                <Typography variant="body2" style={{marginTop: 16, marginBottom: 0}}>
                  {t('themeSettings.linkCorrectionInfo')}
                </Typography>       
                <div className={classes.blacklistForm}>
                  <TextField
                    disabled={(!this.state.observe || !this.state.observeLinks)}
                    value={this.state.blacklistLink}
                    onChange={this.handleChange('blacklistLink')}
                    classes={{root: classes.textField}}
                    placeholder="Enter a link like: /some_specific_site"
                    fullWidth />
                  {this.state.blacklistLink != '' && 
                    <Button onClick={this.handleAddLink} size="small" color="primary" variant="contained" className={classes.addLinkBtn}>{t('themeSettings.addLink')}</Button>
                  }
                </div>
                <div className={classes.blacklist}>
                  <Table disabled={!this.state.observe}>
                    <TableBody>
                      {this.state.linksBlacklist.length === 0 &&
                        <TableRow className={classes.row} padding="dense">
                          <TableCell component="th" scope="row" padding="checkbox" style={{opacity: (this.state.observe && this.state.observeLinks) ? 1 : .5,  textalign: 'center'}}>
                            <Typography variant="subtitle1" textalign="center">{t('themeSettings.emptyBlacklist')}</Typography>
                          </TableCell>
                        </TableRow>
                      }
                      {this.state.linksBlacklist.map(link => (
                        <TableRow className={classes.row} key={link} padding="dense">
                          <TableCell component="th" scope="row" style={{opacity: (this.state.observe && this.state.observeLinks) ? 1 : .5}}>
                            {link}
                          </TableCell>
                          <TableCell align="right">
                            {(this.state.observe && this.state.observeLinks && link != '') &&
                              <Link onClick={() => this.handleDeleteLink(link)} underline="hover">{t('system.delete')}</Link>
                            }
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>                  
                </div>
              </FormGroup>
            </FormControl>  

            <FormControl component="fieldset" className={classes.formControl}>
              <FormGroup>
                <FormLabel component="legend">
                  {t('themeSettings.nonStrictTitle')}
                  <FormControlLabel
                    control={
                      <Switch checked={this.state.nonStrict} onChange={this.handleChange('nonStrict')} value="nonStrict" />
                    }
                    className={classes.switchContainer}
                    label={<Typography variant="caption">{this.state.nonStrict ? t('system.enabled') : t('system.disabled')}</Typography>}
                    labelPlacement="start"
                  />
                </FormLabel>
                <Divider style={{marginTop: 16, marginBottom: 0}} /> 
                <Typography variant="body2" style={{marginTop: 16, marginBottom: 8}}>
                  {t('themeSettings.nonStrictInfo')}
                </Typography>          
              </FormGroup>
            </FormControl> 

            <FormControl component="fieldset" className={classes.formControl}>
              <FormGroup>
                <FormLabel component="legend">
                  {t('themeSettings.languageInCartAttributeTitle')}
                  <FormControlLabel
                    control={
                      <Switch checked={this.state.languageInCartAttribute} onChange={this.handleChange('languageInCartAttribute')} value="languageInCartAttribute" />
                    }
                    className={classes.switchContainer}
                    label={<Typography variant="caption">{this.state.languageInCartAttribute ? t('system.enabled') : t('system.disabled')}</Typography>}
                    labelPlacement="start"
                  />
                </FormLabel>
                <Divider style={{marginTop: 16, marginBottom: 0}} /> 
                <Typography variant="body2" style={{marginTop: 16, marginBottom: 8}}>
                  {t('themeSettings.languageInCartAttributeInfo')}
                </Typography>          
              </FormGroup>
            </FormControl> 

            <FormControl component="fieldset" className={classes.formControl}>
              <FormGroup>
                <FormLabel component="legend">
                  {t('themeSettings.debuggingTitle')}
                  <FormControlLabel
                    control={
                      <Switch checked={this.state.debug} onChange={this.handleChange('debug')} value="debug" />
                    }
                    className={classes.switchContainer}
                    label={<Typography variant="caption">{this.state.debug ? t('system.enabled') : t('system.disabled')}</Typography>}
                    labelPlacement="start"
                  />
                </FormLabel>
                <Divider style={{marginTop: 16, marginBottom: 0}} /> 
                <Typography variant="body2" style={{marginTop: 16, marginBottom: 8}}>
                  {t('themeSettings.debuggingInfo')}
                </Typography>          
              </FormGroup>
            </FormControl> 
          </Grid>


          
          <Grid size={12} style={{paddingBottom: 0}}>
            <Typography variant="h6" component="h3">{t('themeSettings.versionMigration')}</Typography>
          </Grid>
          <Grid size={{ xs: 12, lg: 6 }}>
            {/*<FormControl component="fieldset" className={classes.formControl}>
              <FormGroup>
                <FormLabel component="legend">
                  {t('themeSettings.versionMigration')}
                </FormLabel>
                <Divider style={{marginTop: 16, marginBottom: 0}} /> 
                {this.state.removingV1CodeComplete ? (
                  <Typography variant="body2" style={{marginTop: 16, marginBottom: 16}}>{t('themeSettings.removeV1CodeInfo1')}</Typography>
                ) : (
                  <Typography variant="body2" style={{marginTop: 16, marginBottom: 16}}>{t('themeSettings.removeV1CodeInfo2')}</Typography>
                )}
                <div>
                  <Button variant="outlined" elevation={0} size="medium" color="inherit" onClick={() => this.deleteV1Code(currentTheme.id)} style={{marginTop: 16}}>
                    {t('themeSettings.removeV1Code')}
                    {this.state.removingV1Code &&
                    <Box position="relative" display="inline-flex">
                      <CircularProgress color="primary" size={18} style={{marginLeft: 10, marginRight: 10}} />
                      <Typography variant="caption" component="div" color="text.secondary">{`${Math.round(
                        this.state.removingV1CodeProgress,
                      )}%`}</Typography>
                    </Box>
                    }
                  </Button>
                </div>
              </FormGroup>
            </FormControl>
            */}
            <FormControl component="fieldset" className={classes.formControl}>
              <FormGroup>
                <FormLabel component="legend">
                  {t('themeSettings.loadJqueryTitle')}      
                  <FormControlLabel
                    control={
                      <Switch checked={this.state.loadJquery} onChange={this.handleChange('loadJquery')} value="loadJquery" />
                    }
                    className={classes.switchContainer}
                    label={<Typography variant="caption">{this.state.loadJquery ? t('system.enabled') : t('system.disabled')}</Typography>}
                    labelPlacement="start"
                  />
                </FormLabel>
                <Divider style={{marginTop: 16, marginBottom: 0}} /> 
                <Typography variant="body2" style={{marginTop: 16, marginBottom: 0}}>
                  {t('themeSettings.loadJqueryInfo')}
                </Typography>     
              </FormGroup>
            </FormControl>

          </Grid>
          <Grid size={{ xs: 12, lg: 6 }}>
            
          </Grid>

        </Grid>
      </TabContainer>
    );
  }
  
  setGlobalValue = (name, value) => {
    this.setState({ 
      [name]: value,
      settingsChanged: true,
    }, 
      this.checkSettingsDiff
    );
  }

  /* DEPRECATED
  handleCustomizeScriptsSelect = (panel) => (event, isExpanded) => {
    if(!isExpanded) {
      this.setState({customizedScriptExpanded: ''})
    } else {
      this.loadCustomAsset(panel);
    }
  };
  onCustomizeScriptsSelect = (event, index) => {
    this.loadCustomAsset(index);
  }

  loadCustomAsset = (panel, isExpanded) => {
    if(panel == false) return false;

    this.setState({isLoadingScript: true, isLoadingScriptName: panel});

    if(this.state[panel] === null) {
      API.getCustomAsset(
        this.props.editTheme,
        {key: fileNames[panel]},
        (res) => {
          if(res.success && res.value) {
            this.setState({
              ['current' + panel.charAt(0).toUpperCase()+panel.slice(1)]: res.value.value, 
              [panel]: res.value.value, 
              isLoadingScript: false, 
              isLoadingScriptName: '', 
              customizedScriptExpanded: panel,
              showKnowWhatYouAreDoingDialog: panel !== 'lyRTLCSS' ? true : false,
            });
            this.setGlobalValue(panel, res.value.value);
          }
      });
    } else {
      this.setState({
        isLoadingScript: false, 
        isLoadingScriptName: '', 
        customizedScriptExpanded: panel,
        showKnowWhatYouAreDoingDialog: panel !== 'lyRTLCSS' ? true : false,
      });
    }
  }

  restoreFromLocalAsset = (panel, isExpanded) => {
    this.setState({isLoadingScript: true, isLoadingScriptName: panel});

    API.restoreFromLocalAsset(
      this.props.editTheme,
      {key: fileNames[panel].replace('snippets/', '').replace('layout/', '').replace('assets/', '')},
      (res) => {
        if(res.script_settings) {
          this.setState({
            ['current' + panel.charAt(0).toUpperCase()+panel.slice(1)]: res.value, 
            [panel]: res.value, 
            isLoadingScript: false, 
            isLoadingScriptName: '', 
            scriptSettings: res.script_settings, 
            updateScripts: this.checkUpdateScriptsAvailable(res.script_settings)
          });
          this.setGlobalValue(panel, res.value);
        }
    });
  }

  onCloseLoadDefaultDialog = () => {
    this.setState({showConfirmLoadDefaultDialog: false})
  }
  onSubmitConfirmLoadDefaultDialog = () => {
    this.setState({[this.state.customizedScriptExpanded]: null}, () => {
      this.restoreFromLocalAsset(this.state.customizedScriptExpanded, true);
    });
  }

  handleSelectHistoryEntry = (data) => {
    //console.log(data); //, fileNames, data.id.split('_')[1]);

    const val = data.id.split('_')[1];
    const varName = Object.keys(fileNames).find(key => fileNames[key] === val);

    this.setGlobalValue(varName, data.value);
  }

  renderEntagledInfoIcon = () => {
    const { scriptSettings } = this.state;
    const { t, classes } = this.props;

    return <span style={{position: 'absolute', marginLeft: -28, transform: 'rotate(90deg)'}}>
      {scriptSettings.locked !== null &&
        <Tooltip title={t('themeSettings.customizedEntangledInfo')} arrow>
          <LinkIcon />
        </Tooltip>
      }
    </span>
  }

  renderCustomizeScripts = () => {
    if(!this.props.themes.themes.find(x => x.id == this.props.editTheme) || !this.state.scriptSettings) {
      return;
    }

    const currentTheme = this.props.themes.themes.find(x => x.id == this.props.editTheme);
    const { t, classes } = this.props;
    const { scriptSettings, customizedScriptExpanded } = this.state;

    let themeScriptVersionLabel = null;
    let lyLiquidScriptVersionLabel = null;
    let lyCoreScriptsVersionLabel = null;
    let lyGetCustomsVersionLabel = null;
    let lySwitcherFactoryVersionLabel = null;
    let lyRTLCSSVersionLabel = null;

    let themeScriptLatestVersionLabel = null;
    let lyLiquidScriptLatestVersionLabel = null;
    let lyCoreScriptsLatestVersionLabel = null;
    let lyGetCustomsLatestVersionLabel = null;
    let lySwitcherFactoryLatestVersionLabel = null;
    let lyRTLCSSLatestVersionLabel = null;

    let themeScriptUpdateAvailable = false;
    let lyLiquidScriptUpdateAvailable = false;
    let lyCoreScriptsUpdateAvailable = false;
    let lyGetCustomsUpdateAvailable = false;
    let lySwitcherFactoryUpdateAvailable = false;
    let lyRTLCSSUpdateAvailable = false;

    if(scriptSettings && scriptSettings.versions) {
      themeScriptVersionLabel = scriptSettings.versions["current"]["layout/theme.liquid"];
      themeScriptVersionLabel = 'version ' + decimalToSemanticVersion(themeScriptVersionLabel);

      lyLiquidScriptVersionLabel = scriptSettings.versions["current"]["snippets/ly-liquid-scripts.liquid"];
      lyLiquidScriptVersionLabel = 'version ' + decimalToSemanticVersion(lyLiquidScriptVersionLabel);
      
      lyCoreScriptsVersionLabel = scriptSettings.versions["current"]["snippets/ly-core-scripts.liquid"];
      lyCoreScriptsVersionLabel = 'version ' + decimalToSemanticVersion(lyCoreScriptsVersionLabel);
      
      lyGetCustomsVersionLabel = scriptSettings.versions["current"]["snippets/ly-get-customs.liquid"];
      lyGetCustomsVersionLabel = 'version ' + decimalToSemanticVersion(lyGetCustomsVersionLabel);

      lySwitcherFactoryVersionLabel = scriptSettings.versions["current"]["snippets/ly-switcher-factory.liquid"];
      lySwitcherFactoryVersionLabel = 'version ' + decimalToSemanticVersion(lySwitcherFactoryVersionLabel);

      lyRTLCSSVersionLabel = scriptSettings.versions["current"]["assets/ly-rtl.css.liquid"];
      lyRTLCSSVersionLabel = 'version ' + decimalToSemanticVersion(lyRTLCSSVersionLabel);

      themeScriptLatestVersionLabel = scriptSettings.versions["latest"]["layout/theme.liquid"];
      themeScriptLatestVersionLabel = decimalToSemanticVersion(themeScriptLatestVersionLabel);

      lyLiquidScriptLatestVersionLabel = scriptSettings.versions["latest"]["snippets/ly-liquid-scripts.liquid"];
      lyLiquidScriptLatestVersionLabel = decimalToSemanticVersion(lyLiquidScriptLatestVersionLabel);
      
      lyCoreScriptsLatestVersionLabel = scriptSettings.versions["latest"]["snippets/ly-core-scripts.liquid"];
      lyCoreScriptsLatestVersionLabel = decimalToSemanticVersion(lyCoreScriptsLatestVersionLabel);
      
      lyGetCustomsLatestVersionLabel = scriptSettings.versions["latest"]["snippets/ly-get-customs.liquid"];
      lyGetCustomsLatestVersionLabel = decimalToSemanticVersion(lyGetCustomsLatestVersionLabel);

      lySwitcherFactoryLatestVersionLabel = scriptSettings.versions["latest"]["snippets/ly-switcher-factory.liquid"];
      lySwitcherFactoryLatestVersionLabel = decimalToSemanticVersion(lySwitcherFactoryLatestVersionLabel);

      lyRTLCSSLatestVersionLabel = scriptSettings.versions["latest"]["assets/ly-rtl.css.liquid"];
      lyRTLCSSLatestVersionLabel = decimalToSemanticVersion(lyRTLCSSLatestVersionLabel);

      themeScriptUpdateAvailable = compare(decimalToSemanticVersion(scriptSettings.versions["latest"]["layout/theme.liquid"]), decimalToSemanticVersion(scriptSettings.versions["current"]["layout/theme.liquid"]), '>');
      lyLiquidScriptUpdateAvailable = compare(decimalToSemanticVersion(scriptSettings.versions["latest"]["snippets/ly-liquid-scripts.liquid"]), decimalToSemanticVersion(scriptSettings.versions["current"]["snippets/ly-liquid-scripts.liquid"]), '>');
      lyCoreScriptsUpdateAvailable = compare(decimalToSemanticVersion(scriptSettings.versions["latest"]["snippets/ly-core-scripts.liquid"]), decimalToSemanticVersion(scriptSettings.versions["current"]["snippets/ly-core-scripts.liquid"]), '>');
      lyGetCustomsUpdateAvailable = compare(decimalToSemanticVersion(scriptSettings.versions["latest"]["snippets/ly-get-customs.liquid"]), decimalToSemanticVersion(scriptSettings.versions["current"]["snippets/ly-get-customs.liquid"]), '>');
      lySwitcherFactoryUpdateAvailable = compare(decimalToSemanticVersion(scriptSettings.versions["latest"]["snippets/ly-switcher-factory.liquid"]), decimalToSemanticVersion(scriptSettings.versions["current"]["snippets/ly-switcher-factory.liquid"]), '>');
      lyRTLCSSUpdateAvailable = compare(decimalToSemanticVersion(scriptSettings.versions["latest"]["assets/ly-rtl.css.liquid"]), decimalToSemanticVersion(scriptSettings.versions["current"]["assets/ly-rtl.css.liquid"]), '>');
    }

    return (
      <TabContainer className={classes.customizeScriptsWrapper}>
        <React.Fragment>
          <div className="container">

            <Tabs
              orientation="vertical"
              variant="scrollable"
              value={customizedScriptExpanded ? customizedScriptExpanded : false}
              onChange={this.onCustomizeScriptsSelect}
              aria-label="Vertical tabs example"
              className={classes.tabsLvl2}
            >
              <div className={classes.folderLabel}><FolderOpenIcon /> layout/</div>
              <Tab className={classes.tabLvl2} value={'themeScript'} label={<Badge color={'secondary'} badgeContent={themeScriptUpdateAvailable ? 'update' : null} variant="dot" invisible={scriptSettings.customized && !scriptSettings.customized["layout/theme.liquid"]===true} classes={{badge: classes.customizedBadge}}>theme.liquid</Badge>} {...a11yProps('themeScript')} />
              <div className={classes.folderLabel}><FolderOpenIcon /> snippets/</div>
              <Tab className={classes.tabLvl2} value={'lyCoreScripts'} label={<Badge color="secondary" variant="dot" badgeContent={lyCoreScriptsUpdateAvailable ? 'update' : null} invisible={scriptSettings.customized && !scriptSettings.customized["snippets/ly-core-scripts.liquid"]===true} classes={{badge: classes.customizedBadge}}>{this.renderEntagledInfoIcon()}ly-core-scripts.liquid</Badge>} {...a11yProps('lyCoreScripts')} />
              <Tab className={classes.tabLvl2} value={'lySwitcherFactory'} label={<Badge color={lySwitcherFactoryUpdateAvailable ? 'error' : 'secondary'} variant="dot" badgeContent={lySwitcherFactoryUpdateAvailable ? 'update' : null} invisible={scriptSettings.customized && !scriptSettings.customized["snippets/ly-switcher-factory.liquid"]===true} classes={{badge: classes.customizedBadge}}>{this.renderEntagledInfoIcon()}ly-switcher-factory.liquid</Badge>} {...a11yProps('lySwitcherFactory')} />
              <Tab className={classes.tabLvl2} value={'lyLiquidScript'} label={<Badge color="secondary" variant="dot" badgeContent={lyLiquidScriptUpdateAvailable ? 'update' : null} invisible={scriptSettings.customized && !scriptSettings.customized["snippets/ly-liquid-scripts.liquid"]===true} classes={{badge: classes.customizedBadge}}>ly-liquid-scripts.liquid</Badge>} {...a11yProps('lyLiquidScript')} />
              <Tab className={classes.tabLvl2} value={'lyGetCustoms'} label={<Badge color="secondary" variant="dot" badgeContent={lyGetCustomsUpdateAvailable ? 'update' : null} invisible={scriptSettings.customized && !scriptSettings.customized["snippets/ly-get-customs.liquid"]===true} classes={{badge: classes.customizedBadge}}>ly-get-customs.liquid</Badge>} {...a11yProps('lyGetCustoms')} />
              <div className={classes.folderLabel}><FolderOpenIcon /> assets/</div>
              <Tab className={classes.tabLvl2} value={'lyRTLCSS'} label={<Badge color="secondary" variant="dot" badgeContent={!lyRTLCSSUpdateAvailable ? 'update' : null} invisible={scriptSettings.customized && !scriptSettings.customized["assets/ly-rtl.css.liquid"]===true} classes={{badge: classes.customizedBadge}}>ly-rtl.css.liquid</Badge>} {...a11yProps('lyRTLCSS')} />
            </Tabs>

            {!customizedScriptExpanded &&
              <div className={classes.tabPanel} style={{padding: 16, textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                <Typography variant="h6" component="h3">{t('themeSettings.customizeTitle')}</Typography>
                <Typography>
                  <Trans i18nKey={'themeSettings.customizeInfo'}></Trans>
                </Typography>
              </div>
            }
            
            <TabPanel className={classes.tabPanel} value={customizedScriptExpanded} index={'themeScript'}>
              <Typography className={classes.customizeScriptsHeading} component="div">
                layout/theme.liquid
                {scriptSettings ? (<Chip variant="outlined" size="small" label={ themeScriptVersionLabel } className={classes.versionTag} />) : (null)}
                {scriptSettings && scriptSettings.customized && scriptSettings.customized["layout/theme.liquid"] ? (<Chip variant="outlined" size="small" label={t('themeSettings.customized')} className={classNames(classes.versionTag, classes.customizedTag)} />) : (null)}
                {themeScriptUpdateAvailable ? (<Chip variant="outlined" size="small" label={t('themeSettings.customizeUpdateAvailable')} className={classNames(classes.versionTag, classes.updateTag)} />) : (null)}
              </Typography>

              <div className={classes.restoreBtnArea}>
                <LocalHistorySelect
                  id="layout/theme.liquid"
                  language="null"
                  onSelect={this.handleSelectHistoryEntry}
                  currentValue={this.state.themeScript}
                />
                {this.state.customizedScriptExpanded === 'themeScript' ? (
                <Button variant="outlined" disabled={false} size="small" color="primary" onClick={(e) => {e.stopPropagation(); e.preventDefault(); this.setState({showConfirmLoadDefaultDialog: true})}} className={classes.restoreBtn}>
                  {t('themeSettings.customizeLoadLatest')} {themeScriptLatestVersionLabel}
                </Button>
                ) : null}
              </div>

              <div className={classes.codeMirrorWrapper}>
                <CodeMirror
                  className={classes.codemirror}
                  height="100%"
                  value={this.state.themeScript}
                  resizable={true}
                  options={{
                    mode: 'javascript',
                    //theme: 'material',
                    lineNumbers: true,
                    tabSize: 2,
                  }}
                  onBeforeChange={
                    (editor, data, value) => {
                      this.setGlobalValue('themeScript', value)
                    }
                  }
                />
              </div>
            </TabPanel>

            <TabPanel className={classes.tabPanel} value={customizedScriptExpanded} index={'lyLiquidScript'}>
              <Typography className={classes.customizeScriptsHeading} component="div">
                snippets/ly-liquid-scripts.liquid
                {scriptSettings ? (<Chip variant="outlined" size="small" label={ lyLiquidScriptVersionLabel } className={classes.versionTag} />) : (null)}
                {scriptSettings && scriptSettings.customized && scriptSettings.customized["snippets/ly-liquid-scripts.liquid"] ? (<Chip variant="outlined" size="small" label={t('themeSettings.customized')} className={classNames(classes.versionTag, classes.customizedTag)} />) : (null)}
                {lyLiquidScriptUpdateAvailable ? (<Chip variant="outlined" size="small" label={t('themeSettings.customizeUpdateAvailable')} className={classNames(classes.versionTag, classes.updateTag)} />) : (null)}
              </Typography>

              <div className={classes.restoreBtnArea}>
                <LocalHistorySelect
                  id="snippets/ly-liquid-scripts.liquid"
                  language="null"
                  onSelect={this.handleSelectHistoryEntry}
                  currentValue={this.state.lyLiquidScript}
                />
                {this.state.customizedScriptExpanded === 'lyLiquidScript' ? (
                  <Button variant="outlined" disabled={false} size="small" color="primary" onClick={(e) => {e.stopPropagation(); e.preventDefault(); this.setState({showConfirmLoadDefaultDialog: true})}} className={classes.restoreBtn}>
                    {t('themeSettings.customizeLoadLatest')} {lyLiquidScriptLatestVersionLabel}
                  </Button>
                  ) : (
                  null
                  )
                }
              </div>
              
              <div className={classes.codeMirrorWrapper}>
                <CodeMirror
                  className={classes.codemirror}
                  height="100%"
                  value={this.state.lyLiquidScript}
                  options={{
                    mode: 'javascript',
                    //theme: 'material',
                    lineNumbers: true,
                    tabSize: 2,
                    
                  }}
                  onBeforeChange={
                    (editor, data, value) => {
                      this.setGlobalValue('lyLiquidScript', value)
                    }
                  }
                />
              </div>
            </TabPanel>
            
            <TabPanel className={classes.tabPanel} value={customizedScriptExpanded} index={'lyCoreScripts'}>
              <Typography className={classes.customizeScriptsHeading} component="div">
                snippets/ly-core-scripts.liquid
                {scriptSettings ? (<Chip variant="outlined" size="small" label={ lyCoreScriptsVersionLabel } className={classes.versionTag} />) : ( null )}
                {scriptSettings && scriptSettings.customized && scriptSettings.customized["snippets/ly-core-scripts.liquid"] ? (<Chip variant="outlined" size="small" label={t('themeSettings.customized')} className={classNames(classes.versionTag, classes.customizedTag)} />) : (null)}
                {lyCoreScriptsUpdateAvailable ? (<Chip variant="outlined" size="small" label={t('themeSettings.customizeUpdateAvailable')} className={classNames(classes.versionTag, classes.updateTag)} />) : (null)}
              </Typography>

              <div className={classes.restoreBtnArea}>
                <LocalHistorySelect
                  id="snippets/ly-core-scripts.liquid"
                  language="null"
                  onSelect={this.handleSelectHistoryEntry}
                  currentValue={this.state.lyCoreScripts}
                />
                {this.state.customizedScriptExpanded === 'lyCoreScripts' ? (
                <Button variant="outlined" disabled={false} size="small" color="primary" onClick={(e) => {e.stopPropagation(); e.preventDefault(); this.setState({showConfirmLoadDefaultDialog: true})}} className={classes.restoreBtn}>
                  {t('themeSettings.customizeLoadLatest')} {lyCoreScriptsLatestVersionLabel}
                </Button>
                ) : null }
              </div>

              <div className={classes.codeMirrorWrapper}>
                <CodeMirror
                  className={classes.codemirror}
                  height="100%"
                  value={this.state.lyCoreScripts}
                  options={{
                    mode: 'javascript',
                    //theme: 'material',
                    lineNumbers: true,
                    tabSize: 2,
                    
                  }}
                  onBeforeChange={
                    (editor, data, value) => {
                      this.setGlobalValue('lyCoreScripts', value)
                    }
                  }
                />
              </div>
            </TabPanel>

            <TabPanel className={classes.tabPanel} value={customizedScriptExpanded} index={'lyGetCustoms'}>
              <Typography className={classes.customizeScriptsHeading} component="div">
                snippets/ly-get-customs.liquid
                {scriptSettings ? (<Chip variant="outlined" size="small" label={ lyGetCustomsVersionLabel } className={classes.versionTag} />) : ( null )}
                {scriptSettings && scriptSettings.customized && scriptSettings.customized["snippets/ly-get-customs.liquid"] ? (<Chip variant="outlined" size="small" label={t('themeSettings.customized')} className={classNames(classes.versionTag, classes.customizedTag)} />) : (null)}
                {lyGetCustomsUpdateAvailable ? (<Chip variant="outlined" size="small" label={t('themeSettings.customizeUpdateAvailable')} className={classNames(classes.versionTag, classes.updateTag)} />) : (null)}
              </Typography>

              <div className={classes.restoreBtnArea}>
                <LocalHistorySelect
                  id="snippets/ly-get-customs.liquid"
                  language="null"
                  onSelect={this.handleSelectHistoryEntry}
                  currentValue={this.state.lyGetCustoms}
                />
                {this.state.customizedScriptExpanded === 'lyGetCustoms' ? (
                <Button variant="outlined" disabled={false} size="small" color="primary" onClick={(e) => {e.stopPropagation(); e.preventDefault(); this.setState({showConfirmLoadDefaultDialog: true})}} className={classes.restoreBtn}>
                  {t('themeSettings.customizeLoadLatest')} {lyGetCustomsLatestVersionLabel}
                </Button>
                ) : (
                null
                )}
              </div>

              <div className={classes.codeMirrorWrapper}>
                <CodeMirror
                  className={classes.codemirror}
                  height="100%"
                  value={this.state.lyGetCustoms}
                  options={{
                    mode: 'javascript',
                    //theme: 'material',
                    lineNumbers: true,
                    tabSize: 2,
                    
                  }}
                  onBeforeChange={
                    (editor, data, value) => {
                      this.setGlobalValue('lyGetCustoms', value)
                    }
                  }
                />
              </div>
            </TabPanel>

            <TabPanel className={classes.tabPanel} value={customizedScriptExpanded} index={'lySwitcherFactory'}>
              <Typography className={classes.customizeScriptsHeading} component="div">
                snippets/ly-switcher-factory.liquid
                {scriptSettings ? (<Chip variant="outlined" size="small" label={ lySwitcherFactoryVersionLabel } className={classes.versionTag} />) : ( null )}
                {scriptSettings && scriptSettings.customized && scriptSettings.customized["snippets/ly-switcher-factory.liquid"] ? (<Chip variant="outlined" size="small" label={t('themeSettings.customized')} className={classNames(classes.versionTag, classes.customizedTag)} />) : (null)}
                {lySwitcherFactoryUpdateAvailable ? (<Chip variant="outlined" size="small" label={t('themeSettings.customizeUpdateAvailable')} className={classNames(classes.versionTag, classes.updateTag)} />) : (null)}
              </Typography>
              <div className={classes.restoreBtnArea}>
                <LocalHistorySelect
                  id="snippets/ly-switcher-factory.liquid"
                  language="null"
                  onSelect={this.handleSelectHistoryEntry}
                  currentValue={this.state.lySwitcherFactory}
                />
                {this.state.customizedScriptExpanded === 'lySwitcherFactory' ? (
                <Button variant="outlined" disabled={false} size="small" color="primary" onClick={(e) => {e.stopPropagation(); e.preventDefault(); this.setState({showConfirmLoadDefaultDialog: true})}} className={classes.restoreBtn}>
                  {t('themeSettings.customizeLoadLatest')} {lySwitcherFactoryLatestVersionLabel}
                </Button>
                ) : (
                null
                )}
              </div>
              <div className={classes.codeMirrorWrapper}>
                <CodeMirror
                  className={classes.codemirror}
                  height="100%"
                  value={this.state.lySwitcherFactory}
                  options={{
                    mode: 'javascript',
                    //theme: 'material',
                    lineNumbers: true,
                    tabSize: 2,
                    
                  }}
                  onBeforeChange={
                    (editor, data, value) => {
                      this.setGlobalValue('lySwitcherFactory', value)
                    }
                  }
                />
              </div>
            </TabPanel>

            <TabPanel className={classes.tabPanel} value={customizedScriptExpanded} index={'lyRTLCSS'}>
              <Typography className={classes.customizeScriptsHeading} component="div">
                assets/ly-rtl.css.liquid
                {scriptSettings ? (<Chip variant="outlined" size="small" label={ lyRTLCSSVersionLabel } className={classes.versionTag} />) : ( null )}
                {scriptSettings && scriptSettings.customized && scriptSettings.customized["assets/ly-rtl.css.liquid"] ? (<Chip variant="outlined" size="small" label={t('themeSettings.customized')} className={classNames(classes.versionTag, classes.customizedTag)} />) : (null)}
                {lyRTLCSSUpdateAvailable ? (<Chip variant="outlined" size="small" label={t('themeSettings.customizeUpdateAvailable')} className={classNames(classes.versionTag, classes.updateTag)} />) : (null)}
              </Typography>
              <div className={classes.restoreBtnArea}>
                <LocalHistorySelect
                  id="assets/ly-rtl.css.liquid"
                  language="null"
                  onSelect={this.handleSelectHistoryEntry}
                  currentValue={this.state.lyRTLCSS}
                />
                {this.state.customizedScriptExpanded === 'lyRTLCSS' ? (
                <Button variant="outlined" disabled={false} size="small" color="primary" onClick={(e) => {e.stopPropagation(); e.preventDefault(); this.setState({showConfirmLoadDefaultDialog: true})}} className={classes.restoreBtn}>
                  {t('themeSettings.customizeLoadLatest')} {lyRTLCSSLatestVersionLabel}
                </Button>
                ) : (
                null
                )}
              </div>
              <div className={classes.codeMirrorWrapper}>
                <CodeMirror
                  className={classes.codemirror}
                  height="100%"
                  value={this.state.lyRTLCSS}
                  options={{
                    mode: 'css',
                    //theme: 'material',
                    lineNumbers: true,
                    tabSize: 2,
                    
                  }}
                  onBeforeChange={
                    (editor, data, value) => {
                      this.setGlobalValue('lyRTLCSS', value)
                    }
                  }
                />
              </div>
            </TabPanel>

            {this.state.isLoadingScript &&
              <div className={classes.codeMirrorLoadingSign}>
                <CircularProgress color="primary" size={20} style={{margin: 'auto'}} thickness={2}/>
              </div>
            }
          </div>
        </React.Fragment>
      </TabContainer>
    );
  }
  */


  render() {
    if(!this.props.themes.themes.find(x => x.id == this.props.editTheme)) {
      return null
    }

    const { t, classes } = this.props;
    const { tabIndex, pending, loaded, noticeShow, noticeType, isPublished, updateScripts } = this.state;
    const currentTheme = this.props.themes.themes.find(x => x.id == this.props.editTheme);
    let noticeText = '';
    let _noticeType = noticeType;
    if(
      this.props.langify_code_in_theme === false && 
      (!this.props.uuid || typeof this.props.uuid === 'string' && this.props.disabled === true)
    ) {
      noticeText = <span><Trans>{'themeSettings.alertNotPublished'}</Trans></span>
    } else if(updateScripts) {
      noticeText = <span><Trans>{'themeSettings.alertNewerVersion'}</Trans></span>
      _noticeType = 'info';
    }
    const themeIdProblem = this.appEmbedThemeIdProblem();
    if(themeIdProblem && !noticeText) {
      // short in the bar, the details wait in the opened section
      noticeText = <span><Trans>{themeIdProblem.actual === null ? 'themeSettings.alertThemeIdMissing' : 'themeSettings.alertThemeIdMismatch'}</Trans></span>
      _noticeType = 'error';
    }

    return(
      <React.Fragment>
        <CollapsableSection
          deeplink="theme-settings"
          className={classes.collapsableSection}
          title={t('themeSettings.title')}
          ctaBtnHide={!this.state.settingsChanged}
          ctaBtnText={<React.Fragment>{t('system.save')} <SaveAltOutlinedIcon style={{marginLeft: 5}} /></React.Fragment>}
          ctaBtnAction={this.handleSaveThemeSettings}
          ctaBtnProps={{
            disabled: this.state.pending,
          }}
          openBtnHide={false}
          openBtnText={t('themeSettings.configure')}
          cancelBtnHide={false}
          cancelBtnText={t('themeSettings.cancel')}
          noticeShow={(noticeShow || themeIdProblem !== null) && loaded}
          noticeType={_noticeType}
          noticeText={noticeText}
          pending={!loaded}
          onClosed={this.handleCancel}
          onOpened={this.handleOpened}
          pinSectionOnOpen={true}
          scrollToTop={this.state.scrollToTop}
          content={
            <div className={classes.root} style={{ '--ly-section-notice': ((noticeShow || themeIdProblem !== null) && loaded) ? '44px' : '0px' }}>
              <React.Fragment>
                <Tabs  
                  position="static"
                  value={tabIndex} 
                  onChange={this.handleChangeTab}
                  classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
                >
                  <Tab 
                    label={t('themeSettings.generalTab')}
                    classes={{ root: classes.tabRoot, selected: classes.tabSelected }} 
                    disableRipple
                  />
                  <Tab 
                    label={t('themeSettings.advancedTab')}
                    classes={{ root: classes.tabRoot, selected: classes.tabSelected }} 
                    disabled={
                      (typeof this.props.uuid === 'string' && this.props.disabled === true && !this.props.langify_code_in_theme) || 
                      (!this.props.uuid && !this.props.langify_code_in_theme)
                    }
                    disableRipple
                  />
                  {/*
                  <Tab 
                    label={t('themeSettings.customizeTab')}
                    classes={{ root: classes.tabRoot, selected: classes.tabSelected }} 
                    disabled={!isPublished}
                    disableRipple
                  />
                  */}
                  <OptionsMenu
                    onImportFile={this.onImport}
                    onExport={this.onExport}
                    onResaveAll={this.onResaveAll}
                    importLabel={t('themeSettings.import')}
                    exportLabel={t('themeSettings.export')}
                    jsonFormat
                    inlined
                    shopPlan={this.props.shopPlan}
                  />
                </Tabs>
                <Divider />
              </React.Fragment>
              {tabIndex === 0 && this.renderGeneralTab()}
              {tabIndex === 1 && this.renderCoreTab()}
            </div>
          } 
        />       

        <LoadingIndicator
          pending={this.props.master_loading}
          saving={false}
          progress={0}
        />
        <DontAskAgainDialog
          context="ConfirmLoadDefault"
          open={this.state.showConfirmLoadDefaultDialog}
          onClose={this.onCloseLoadDefaultDialog}
          onSubmit={this.onSubmitConfirmLoadDefaultDialog}
          title={t('themeSettings.customizeConfirmLoadTitle')}
          content={t('themeSettings.customizeConfirmLoadInfo')}
        />


        <DontAskAgainDialog
          context="knowWhatYouAreDoing"
          open={this.state.showKnowWhatYouAreDoingDialog}
          onClose={() => { this.setState({showKnowWhatYouAreDoingDialog: false}); }}
          onCancel={() => { this.setState({customizedScriptExpanded: ''}); }}
          onSubmit={null}
          title={t('themeSettings.customizeWarningTitle')}
          content={<span><Trans i18nKey={'themeSettings.customizeWarning'}></Trans></span>}
          icon={<ErrorOutlineRoundedIcon />}
          visuallyHideCheckbox
          suppressBackdropClick
        />
      </React.Fragment>

    );
  }
}

// Accent of the tabs; too dark on a dark ground, hence per mode
const accentColor = (theme) => theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.accentMuted;

const styles = theme => ({
  root: {
    width: '100%',
    margin: 0,
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  collapseToggler: {
    cursor: 'pointer',
    color: `${theme.palette.text.primary} !important`,
    fontWeight: '400 !important',
  },
  icon: {
    marginRight: theme.spacing(2),
    opacity: .5,
  },
  contentContainer: {
    //marginBottom: theme.spacing(2),
  },
  card: {
    //maxWidth: 400,
  },
  media: {
    width: '100%',
    paddingTop: '56.25%', // 16:9
    backgroundColor: theme.palette.mode === 'dark' ? '#2a2a2a' : '#ccc',
  },
  actions: {
    display: 'flex',
  },
  title: {
    fontSize: 16,
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    marginLeft: 'auto',
    [theme.breakpoints.up('sm')]: {
      marginRight: -8,
    },
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
  cardActions: {
    padding: '0px 12px 14px 12px'
  },
  cardHeader: {
    alignItems: 'baseline',
    paddingBottom: 0
  },
  button: {
    marginLeft: 10,
  },
  tabsRoot: {
    //borderBottom: '1px solid #e8e8e8',
  },
  tabsIndicator: {
    backgroundColor: accentColor(theme),
  },
  tabRoot: {
    textTransform: 'initial',
    minWidth: 'auto !important',
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover': {
      color: accentColor(theme),
      opacity: 1,
    },
    '&$tabSelected': {
      color: accentColor(theme),
      fontWeight: theme.typography.fontWeightMedium,
    },
    '&:focus': {
      color: accentColor(theme),
    },
  },
  tabSelected: {

  },



  publishBtn: {
    marginRight: 8,
    background: theme.palette.mode === 'dark' ? '#2e7d32' : '#009900',
    color: '#ffffff',
    '&:hover': {
      background: theme.palette.mode === 'dark' ? '#2e7d32' : '#009900',
      color: '#ffffff',
    }
  },
  unpublishBtn: {
    marginRight: 10,
    marginTop: 24,
    backgroundColor: '#ff5252',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#ff5252',
      color: '#fff',
    }
  },
  formControl: {
    width: '100%',
    marginTop: 0,
    marginBottom: 24,
    '& legend': {
      position: 'relative',
      width: '100%',
    },
    '&.outer': {
      display: 'block',
      marginBottom: 0,
    },
    '& hr': {
      marginTop: '12px !important',
      marginBottom: '0 !important',
      //display: 'none',
    },
    '& p': {
      marginTop: '12px !important',
      marginBottom: '0 !important',
    },
  },
  blacklistForm: {
    marginTop: 10,
    position: 'relative',
  },
  addLinkBtn: {
    position: 'absolute',
    top: 8,
    right: 0,
  },
  blacklist: {
    maxHeight: 250,
    overflow: 'auto',
    backgroundColor: theme.palette.background.default,
  },
  row: {
    height: 'auto !important',
    padding: '4px 0 !important',
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
    '& td': {
      padding: '8px !important',
    },
    '& th': {
      padding: '8px !important',
    }
  },
  textField: {
    backgroundColor: theme.palette.background.default,
    '& input': {
      padding: '14px !important',

    }
  },

  advancedSettingsWrapper: {
    // the notice bar above the section takes its share of the viewport, see the root's style
    height: 'calc(100vh - 225px - var(--ly-section-notice, 0px))',
    overflow: 'hidden',
    overflowY: 'auto',
  },

  customizeScriptsWrapper: {
    // the notice bar above the section takes its share of the viewport, see the root's style
    height: 'calc(100vh - 225px - var(--ly-section-notice, 0px))',
    overflow: 'hidden',
    paddingTop: '0 !important',
    '&>.container': {
      position: 'relative',
      height: '100%',
    }
  },
  switchContainer: {
    position: 'absolute !important',
    right: '8px !important',
    top: 'auto !important',
    height: 16,
  },
  customizeScriptsHeading: {
    color: theme.palette.text.secondary,
    fontSize: '1rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: '400',
    lineHeight: '1',
    letterSpacing: '0.00938em',
    paddingBottom: '16px',
    paddingLeft: 16,
    whiteSpace: 'nowrap'
  },
  codemirror: {
    fontSize: 14,
    height: '100% !important',
    '& .cm-editor': {
      height: '100%',
    },
  },

  restoreBtnArea: {
    position: 'absolute',
    right: 0,
    top: -8,
    marginLeft: '20px',
    backgroundColor: theme.palette.background.paper,
  },
  restoreBtn: {
    color: accentColor(theme),
    backgroundColor: theme.palette.background.paper,
    boxShadow: 'none',
    border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(139, 116, 240, 0.5)' : alpha(theme.palette.accentMuted, 0.5)}`,
    marginLeft: 8,
  },

  versionTag: {
    color: theme.palette.text.secondary,
    margin: '-6px -6px -6px 12px'
  },

  updateTag: {
    backgroundColor: '#ff5252',
    borderColor: '#ff5252',
    color: '#fff',
    marginTop: -8,
    marginLeft: '10px'
  },

  customizedTag: {
    color: theme.palette.text.secondary,
    margin: '-6px -6px -6px 12px'
  },

  divider: {
    '&.large': {
      margin: '24px 0 !important',
    }
  },

  tabsLvl2: {
    display: 'inline-block',
    float: 'left',
    width: 225,
    height: 'calc(100% + 24px)',
    borderRight: `solid 1px ${theme.palette.divider}`,
    paddingTop: 24,
  },
  tabLvl2: {
    paddingLeft: 28,
    '& .MuiTab-root': {
      textTransform: 'none !important',
      textAlign: 'left !important',
    },
    '& .MuiTab-wrapper': {
      textTransform: 'none !important',
      textAlign: 'left !important',
      alignItems: 'start',
    },
  },
  tabPanel: {
    position: 'absolute',
    left: 226,
    right: 0,
    bottom: 0,
    top: 16,
  },
  folderLabel: {
    fontWeight: 'bold',
    padding: '6px 0',
  },

  codeMirrorWrapper: {
    width: 'calc(100% + 24px)',
    height: 'calc(100vh - 275px - var(--ly-section-notice, 0px))',
    borderTop: `solid 1px ${theme.palette.divider}`,
  },
  codeMirrorLoadingSign: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: theme.palette.mode === 'dark' ? 'rgba(18,18,18,.75)' : 'rgba(255,255,255,.75)',
    position: 'absolute',
    top: 0,
    bottom: -24,
    right: -24,
    left: 226,
    zIndex: 100,
  },
  customizedBadge: {
    top: 12,
    right: -8
  }
});

ThemesSection.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  shop: state.shop,
  shopPlan: state.shop.shop.plan,
  themes: state.themes,
  languages: state.languages,
  editTheme: state.themes.edit_theme,
  master_loading: state.master_loading,
  progress: state.progress,
  is_published: state.themes.is_published,
  publish_transations_pending: state.themes.publish_transations_pending,
  unpublish_transations_pending: state.themes.unpublish_transations_pending,
  refresh_transations_pending: state.themes.refresh_transations_pending,
  themeAppExtension: state.themeAppExtension,
  langify_code_in_theme: state.themeAppExtension.langify_code_in_theme,
  langify_app_embed_code_in_theme: state.themeAppExtension.langify_app_embed_code_in_theme,
  uuid: state.themeAppExtension.uuid,
  disabled: state.themeAppExtension.disabled
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      publishTranslations,
      unpublishTranslations,
      refreshTranslations,
      updateSwitcherLanguages,
      syncThemeAppExtension,
      checkThemePublishState,
    },
    dispatch
  )

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(ThemesSection))))
